import React from 'react';
import { createMuiTheme } from '@material-ui/core';
import { ThemeProvider as MuiThemeProvider } from '@material-ui/styles';

const theme = createMuiTheme(
  /**
   * @see https://material-ui.com/customization/themes/#theme-configuration-variables
   */
  {
    // direction: "rtl",
    typography: {
      fontFamily: ['WixMadeforDisplay'].join(','),
    },

    breakpoints: {
      values: {
        sm: 600, // Small screen / phone
        md: 920, // Medium screen / tablet
        lg: 1200, // Large screen / desktop
        xl: 1500,
        xxl: 1800,
      },
    },

    palette: {
      contrastThreshold: 3,
      primary: {
        main: '#d01c1f',
        contrastText: '#fff',
      },
      secondary: {
        main: '#b5b5c3',
        contrastText: '#ffffff',
      },
      error: {
        main: '#0b5785',
      },
      success: {
        main: '#0abb87',
      },
    },
    overrides: {
      MuiButton: {
        // raisedPrimary: {
        //   color: 'white',
        // },
      },

      MuiInputBase: {
        root: {
          '&$disabled': {
            color: 'rgba(0, 0, 0, 0.87)',
          },
        },
      },
    },

    /**
     * @see https://material-ui.com/customization/globals/#default-props
     */

    props: {
      // Name of the component ⚛️
      MuiButtonBase: {
        // The properties to apply
        // raisedPrimary: { color: '#fff' },
        disableRipple: true, // No more ripple, on the whole application 💣!
      },

      // Set default elevation to 1 for popovers.
      MuiPopover: {
        elevation: 1,
      },
    },
  }
);

export default function ThemeProvider(props) {
  const { children } = props;

  return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
}
